// A styled replacement for window.confirm(). <ConfirmDialog/> is mounted once in App.vue.
//
//   import {ask} from '@/confirm'
//   if(!await ask({title:'Send WhatsApp?', message:'…', confirm_label:'Send', icon:'chat'})) return
//
// Options: title, message, details (array of strings shown as a list), warning (highlighted
// line), confirm_label, cancel_label, icon (material symbol), danger (red confirm button),
// input ({label, placeholder, hint, secret}: adds a text box). With `input`, the promise
// resolves to the typed text ('' if left blank) on confirm and to false on cancel.
import {reactive} from 'vue'

export const confirm_state=reactive({open:false,options:{},resolve:null,value:''})

export function ask(options){
    // Only one question at a time: a new one answers the old one with "no".
    if(confirm_state.resolve){
        confirm_state.resolve(false)
    }
    return new Promise(resolve=>{
        confirm_state.options=options
        confirm_state.value=''
        confirm_state.resolve=resolve
        confirm_state.open=true
    })
}

export function answer(value){
    const resolve=confirm_state.resolve
    confirm_state.resolve=null
    confirm_state.open=false
    if(resolve){
        resolve(value && confirm_state.options.input ? confirm_state.value.trim() : value)
    }
    confirm_state.value=''
}

// The confirmation shown before anything that sends a WhatsApp message.
export function ask_whatsapp({title,to,message,warning,input,confirm_label='Send WhatsApp'}){
    const recipients=(Array.isArray(to) ? to : [to]).map(person=>{
        const phone=person.user && person.user.cellphone
        return phone ? `${person.ui} · ${phone}` : `${person.ui} · ⚠ no phone number on file`
    })
    return ask({title,message,details:recipients,warning,input,confirm_label,icon:'chat'})
}
